export * from "./reducer";
export * from "./effects";
export * from "./state";

import * as IconsStoreActions from "./actions";
import * as IconsStoreSelectors from "./selectors";

export { IconsStoreActions, IconsStoreSelectors };
